import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { toggleInscripcion } from '../../../appStore/convocatoria';
import { useConcurso } from '../../../providers/ConcursoProvider';

const AccionesConvocatoriaPublicadaCC = () => {
  const { idLlamadoConcurso } = useConcurso();
  const dispatch = useDispatch();

  const FlexDiv = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: auto;
    margin: 18px auto;
  `;

  return (
    <FlexDiv>
      <ButtonGroup>
        {/* PROCESAR */}
        <DropdownButton as={ButtonGroup} id="dropdown-basic-button" title="Procesar">
          <Dropdown.Item
            onClick={() => {
              if (
                window.confirm(
                  'Se abrirá la inscripción del concurso Nª: ' +
                    idLlamadoConcurso +
                    ' ¿Está seguro?',
                )
              )
                dispatch(toggleInscripcion({ idLlamadoConcurso, abrir: true }));
            }}>
            Abrir Inscripcion
          </Dropdown.Item>
        </DropdownButton>
      </ButtonGroup>
    </FlexDiv>
  );
};

export default AccionesConvocatoriaPublicadaCC;
